import { Navigate } from 'react-router-dom';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_MARKET_HOME,
  MLB_MARKET_PRIMARY,
} from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

export const Market = () => {
  const {
    flags: { useMarketHomePage = false },
  } = useFeatureFlags();
  if (useMarketHomePage) {
    return (
      <Navigate
        to={generateSportPath(ANY_SPORT_MARKET_HOME, { sport: Sport.BASEBALL })}
        replace
      />
    );
  }
  return <Navigate to={MLB_MARKET_PRIMARY} />;
};

export default Market;
